import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import { trackFetchErrors } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchServiceDeskPortal from '../services/index.tsx';
import {
	type Action,
	FETCH_SERVICEDESK_PORTAL,
	fetchServicedeskPortalSuccessAction,
} from '../state/actions.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>) =>
	action$.ofType(FETCH_SERVICEDESK_PORTAL).switchMap(({ payload: { projectId } }) =>
		Observable.fromPromise(fetchServiceDeskPortal(projectId))
			.map((res) => {
				const { id: portalId } = res;
				return fetchServicedeskPortalSuccessAction(portalId);
			})
			.catch((error) => {
				trackFetchErrors({
					error,
					id: 'fetchServicedeskPortal',
					packageName: 'jiraProjectSettingsAppsServicedeskPortalProvider',
					sendToPrivacyUnsafeSplunk: true,
				});
				return Observable.empty<never>();
			}),
	);
